module.exports = __webpack_public_path__ + "media/img/pages/companies/heig_vd-29b1a074a782e87a68fbae6811036c3e.png";